module.exports = __webpack_public_path__ + "img/WalletorRetur-Solid.9dbb213b.svg";